import { usePermission } from '@providers/userContextProvider';

export const useAlertBannerPermissions = () => {
  const hasWriteBannersPermission = usePermission('write:alert_banners');
  const hasReadBannersPermission = usePermission('read:alert_banners');
  const hasTransitionBannersPermissions = usePermission(
    'transition:alert_banners',
  );

  return {
    hasWriteBannersPermission,
    hasReadBannersPermission,
    hasTransitionBannersPermissions,
  };
};
